import Home from "./Home.vue";

class PrivacyPolicy {
    constructor(wrapper, session_id) {
        this.$wrapper = $(wrapper);
        this.session_id = session_id;
        this.make_body();
    }
    make_body() {
        const me = this;
        if (this.$wrapper.get(0).__vue_app__) {
            this.$wrapper.get(0).__vue_app__.unmount();
        }
        this.$component = new Vue({
			el: this.$wrapper.get(0),
			data() {
				return {};
			},
			render(h) {
				return h(Home, { props: {
                    session_id: me.session_id,
                } });
			},
		});
    }
};

frappe.provide("myinvois.app");
myinvois.app.privacy_policy = PrivacyPolicy;
export default PrivacyPolicy;